import create from "zustand";

const useMeasureStore = create((set) => ({
  containerHeight: null,
  setContainerHeight: (value) => set((state) => ({ containerHeight: value }))
}));

export { useMeasureStore };
